<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="90.7 Feedback Control" :useBtnList="[
                    'btnRetrieve' //Retrieve                
                ]" @btnRetrieve="btnRetrieve()">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined>
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-2">
                                                    <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Div : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="div.select" :items="div.items" item-text="name"
                                                            item-value="cd" return-object single-line outlined dense
                                                            @change="btnRetrieve"></v-select>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="3" class="pa-0">
                                    <DxDataGrid id="epms9040" class="listBox02" :ref="epms9040Ref"
                                        :data-source="gridMainList" :remote-operations="false" :hover-state-enabled="true"
                                        :allow-column-resizing="true" :allow-column-reordering="true"
                                        :row-alternation-enabled="true" :show-borders="true" :width="grid.width"
                                        :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                        :auto-navigate-to-focused-row="true" :focused-row-key="focusedRowKey"
                                        :column-hiding-enabled="false" :selection="{ mode: 'none' }"
                                        :sorting="{ mode: 'none' }" @focused-row-changed="onFocusedRowChanged">

                                        <DxColumn data-field="dte" caption="Send Date" width="35%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="shipNo" caption="Ship No" width="25%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />

                                        <DxColumn data-field="mgrNo" caption="Feeback No" width="40%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" />

                                        <DxPaging :enabled="true" :page-size="18" />
                                    </DxDataGrid>
                                </v-col>
                                <v-col cols="9" class="pl-1">
                                    <v-row class="listBox02">
                                    <v-row dense class="form-layout">                                        
                                        <v-col cols="12" class="pa-0">
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Title</span>
                                                </v-col>
                                                <v-col cols="11">
                                                    <v-text-field v-model="headerData.pubSubject" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>

                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>From</span>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field v-model="headerData.deptNm" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>FeedBack Type</span>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field v-model="headerData.fbType" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Request Type</span>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field v-model="headerData.reqType" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Request Date</span>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field v-model="headerData.reqDte" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Content</span>
                                                </v-col>
                                                <v-col cols="11">
                                                    <v-text-field v-model="headerData.contents" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>File Attach</span>
                                                </v-col>
                                                <v-col cols="5">
                                                   <div @click="onClick(1)">
                                                        <a class="pl-2 a-tag">{{ headerData.file1 }}</a>
                                                    </div>
                                                    <div @click="onClick(2)">
                                                        <a class="pl-2 a-tag" >{{ headerData.file2 }}</a>
                                                    </div>
                                                </v-col>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Image Attach</span>
                                                </v-col>
                                                <v-col cols="5">                                                    
                                                    <div @click="onClick(3)">
                                                        <a class="pl-2 a-tag">{{headerData.img1}}</a>
                                                    </div>
                                                    <div @click="onClick(4)">
                                                        <a class="pl-2 a-tag" >{{headerData.img2}}</a>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <!-- ?? -->
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>PIC Comment</span>
                                                </v-col>
                                                <v-col cols="11">
                                                    <v-text-field v-model="headerData.replyCmt" dense outlined
                                                        hide-details="auto" readonly />
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                                                    <span>Supp. Comment</span>
                                                </v-col>
                                                <v-col cols="9">
                                                    <v-text-field v-model="headerData.hmdCmtHvs" dense outlined
                                                        hide-details="auto" />
                                                </v-col>
                                                <v-col cols="2" align="center" class="pr-2 pt-1 formHeader">
                                                    <v-btn variant="outlined" size="small" class="grd-btn"
                                                        @click="btnSubmit()"> Submit </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="pt-2">
                                            <DxDataGrid id="epms9041detail" class="lbDetail" :ref="epms9041detailRef"
                                                :data-source="gridDetailList" :remote-operations="false"
                                                :hover-state-enabled="true" :allow-column-resizing="true"
                                                :allow-column-reordering="true" :row-alternation-enabled="true"
                                                :show-borders="true" :width="grid.width" :show-row-lines="true"
                                                key-expr="id" :focused-row-enabled="true" :column-hiding-enabled="false"
                                                :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                                @cellPrepared="cellPrepared">

                                                <DxColumn caption="Por No" width="15%" data-type="string"
                                                    :allow-editing="false" alignment="center" :visible="true">
                                                    <DxColumn data-field="porNo" caption="Por Seq" width="15%"
                                                        data-type="string" :allow-editing="false" alignment="center"
                                                        :visible="true" />
                                                </DxColumn>

                                                <DxColumn data-field="block" caption="Block" width="8%" data-type="string"
                                                    :allow-editing="false" alignment="center" :visible="true" />

                                                <DxColumn caption="Activity" width="12%" data-type="string"
                                                    :allow-editing="false" alignment="center" :visible="true">
                                                    <DxColumn data-field="mact" caption="BOM Ser" width="12%"
                                                        data-type="string" :allow-editing="false" alignment="center"
                                                        :visible="true" />
                                                </DxColumn>

                                                <DxColumn data-field="partNo" caption="Part No" width="12%"
                                                    data-type="string" :allow-editing="false" alignment="center"
                                                    :visible="true" />

                                                <DxColumn data-field="matlSpec" caption="Material Specification" width="37%"
                                                    data-type="string" :allow-editing="false" alignment="center"
                                                    :visible="true" />

                                                <DxColumn data-field="qty" caption="Part Qty" width="8%" data-type="string"
                                                    :allow-editing="false" alignment="center" :visible="true" />

                                                <DxColumn data-field="mqty" caption="Mistake Qty" width="8%"
                                                    data-type="string" :allow-editing="false" alignment="center"
                                                    :visible="true" />

                                                <DxPaging :enabled="true" :page-size="6" />
                                            </DxDataGrid>
                                        </v-col>
                                    </v-row>  
                                    </v-row>                             
                               </v-col>                               
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { epms9040List, epms9040save, epms9041head, epms9041detail } from '@/api/view/hip/90/epms9040.js'
import { ftpDownload } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify' // message

export default {
    name: 'epms9040',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop
    },
    data() {
        return {
            gridMainList: [],
            gridDetailList: [],
            epms9040Ref: "epms9040Ref",
            epms9041detailRef: "epms9041detailRef",
            headerData: {},
            focusedRowKey: 1,
            div: {
                select: { name: 'Not Comment Yet', cd: '1' },
                items: [
                    { name: 'Not Comment Yet', cd: '1' },
                    { name: 'Already Commented', cd: '2' }
                ]
            }
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms9040Ref)
        },
        gridDetailInstance() {
            return this.GetDataGrid(this.epms9041detailRef)
        }
    },
    methods: {

        btnRetrieve() {

            this.doSearchMain().finally(() => {
                if (!this.gridMainList.length) {
                    console.log('here')
                    this.gridDetailList = []
                    this.headerData = {}
                } else {
                    this.focusedRowKey = 1
                }
            })
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                div: this.div.select.cd,
            }
            console.log(params)
            await epms9040List(params).then(res => {
                let cnt = 1;
                res.list.forEach(e => {
                    e.id = cnt++
                });
                this.gridMainList = res.list
            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },
        async doSearchHead(shipNo, mgrNo) {
            this.openLoading('searching')
            let params = {
                shipNo: shipNo,
                mgrNo: mgrNo,
            }
            //console.log(params)
            this.headerData = {}
            await epms9041head(params).then(res => {
                this.headerData = res.list[0]
            }).finally(() => {
                this.endLoading();
            })
        },
        async doSearchDetail(shipNo, mgrNo) {
            this.openLoading('searching')
            let params = {
                shipNo: shipNo,
                mgrNo: mgrNo,
            }
            this.gridDetailList = []
            await epms9041detail(params).then(res => {
                let list = []
                let cnt = 1;
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, porNo: e.porNo, block: e.block, mact: e.mact, partNo: e.partNo, matlSpec: e.matlSpec, qty: e.qty, mqty: e.qty
                        },
                        {
                            id: cnt++, porNo: e.lineNo, block: e.block, mact: e.bomSerno, partNo: e.partNo, matlSpec: e.matlSpec, qty: e.qty, mqty: e.qty
                        },
                    )
                });
                this.gridDetailList = list
            }).finally(() => {
                this.endLoading();
            })
        },
        async btnSubmit() {

            if (!this.headerData) {
                this.vToastify(this.$t('Data is not selected.'), 'warn')
                return
            }
            let params = {
                shipNo: this.headerData.shipNo,
                mgrNo: this.headerData.mgrNo,
                cmt: this.headerData.hmdCmtHvs
            }
            //console.log(params)

            this.openLoading('searching')

            epms9040save(params).then(res => {
                //console.log(res.body)
                if (res.body === 'OK') {
                    notify(this.$t('Submit data is completed.'), 'success', 3000)
                } else {
                    this.vToastify(this.$t('An error has been occured while submit data. ' + res.body), 'warn')
                }
            })
                .catch(error => {
                    this.vToastify(error, 'warn')
                })
                .finally(() => {
                    this.gridMainInstance.clearSelection()
                    this.btnRetrieve()
                })
        },
        onClick(num) {
            let link
            switch (num) {
                case 1:
                    link = this.headerData.ffile1
                    break;
                case 2:
                    link = this.headerData.ffile2
                    break;
                case 3:
                    link = this.headerData.fimg1
                    break;
                case 4:
                    link = this.headerData.fimg2
                    break;
            }
            link =  "http://ibiz.hvs.com.vn/#/AttachFileOut?Path=" + link.replace(/http:\/\/192.168.50.11\//g, '').replace(/http:\/\/ebiz.hvs.com.vn\//g, '')

            window.open(link)
                       
        },
       
        onFocusedRowChanged(e) {
            this.focusedRowKey = e.component.option('focusedRowKey');

            //console.log('focusRowKey : ' + this.focusedRowKey)

            let shipNo = e.row.data.shipNo
            let mgrNo = e.row.data.mgrNo

            this.doSearchHead(shipNo, mgrNo)
            this.doSearchDetail(shipNo, mgrNo)
        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'data') {
                if (e.column.caption === 'Block' || e.column.caption === 'Part No' || e.column.caption === 'Material Specification' ||
                    e.column.caption === 'Part Qty' || e.column.caption === 'Mistake Qty') {
                    if (e.rowIndex % 2 === 0) {
                        e.cellElement.setAttribute('rowspan', 2)
                    } else {
                        e.cellElement.style.display = 'none'
                    }
                }
            }

        }
    },
    mounted() {
        this.gridDetailInstance.option('defaultPaging', false)
    }
}

</script>

<style lang="scss" scoped>
$redBtn: #FF0000;
$blueBtn: #0000FF;

.form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;

    * {
        border: 0px none !important;
    }

    .row:not(.row__select-no) {
        border-width: 0 0 1px 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }

    .col:not(.quotNo) {
        border-width: 0 1px 0 0 !important;
        border-style: solid !important;
        border-color: gray !important;
    }
}

.formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
}

.a-tag:hover{
     text-decoration: underline;
}

.subTitle {
    font-weight: bold;
    color: black;
}

.subTitle2 {
    font-weight: bold;
    color: red;
}

.lbDetail {
    height: 100vh;
    max-height: calc(100vh - 47.5vh);
}

.grd-btn {
    text-transform: unset !important;
    font-weight: bold;
    height: 24px !important;
    margin-top: 8px !important;
    margin-bottom: 8px !important;

}

.p-cont {
    width: auto;
    padding-left: 2px;
    margin: 0;
    text-align: left;
    font-size: 8pt;
    color: #4980BC;
}

.v-btn:hover {
    color: #0000ff;
}

::v-deep {
    [role=btnReceiptRequest] {
        :not([disabled=disabled]) {
            .v-btn__content {

                div,
                i {
                    color: #{$redBtn} !important;
                }
            }
        }
    }

}

::v-deep {

    [role=btnPrintRequest],
    [role=btnPrintRequestVn] {
        .v-btn__content {

            div,
            i {
                color: #{$blueBtn} !important;
            }
        }
    }
}
</style>